import * as client from "./client";

function createSpindlClient() {
  const el = document.querySelector('script[data-key][data-name="spindl-sdk"]');
  const sdkKey = el && el.getAttribute("data-key");
  if (sdkKey) {
    client.configure({ sdkKey });
    client.enableAutoPageViews();
    client.enableAutoWalletConnects();
  }

  return client;
}

export default createSpindlClient();
